import { ButtonGroup } from 'src/components/atoms';
import { textStyleCss } from 'src/theme/atlas';
import { RoutingDataSource } from 'src/types';
import styled from 'styled-components';

export const RoutingRuleBodyStyled = styled.div<{ hasPaddingBottom: boolean }>`
  padding: 30px 20px ${(props) => (props.hasPaddingBottom ? '30px' : '0')} 20px;
  display: flex;
  row-gap: 20px;
  flex-direction: column;
`;

export const RoutingRuleDataSource = styled.div<{
  $speakUp?: boolean;
  $coi?: boolean;
}>`
  width: ${({ $coi }) => ($coi ? '100%' : '50%')};
  ${({ $speakUp }) =>
    $speakUp &&
    `
    align-self: flex-start;
    text-align: left;
  `}
`;

export const RoutingRuleGroup = styled.div`
  z-index: 3;
`;

export const RoutingRuleHeaderText = styled.h3<{ end?: boolean }>`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleHeading
      : textStyleCss(theme.atlas.typography.semantic.body);
  }}
  margin: 0;
  margin-bottom: 8px;
  ${(props) => props.end && 'align-self: end;'}
`;

export const RoutingRuleDescriptionText = styled.p`
  ${({ theme }) => {
    const isVaultVariant = theme.isVaultVariant;
    return isVaultVariant
      ? theme.newTypography.textStyleBodySmall
      : textStyleCss(theme.atlas.typography.semantic.caption);
  }}
  color: ${(props) => {
    const isVaultVariant = props.theme.isVaultVariant;
    return isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted;
  }};
  margin: 0;
  margin-top: 8px;
`;

export const DividerContainer = styled.div`
  padding: 0 20px;
`;

export const RoutingRuleParameterList = styled.div`
  position: relative;
  padding: 30px 20px;
  display: grid;
  grid-template-columns: 86px 1fr 1fr 86px;
  column-gap: 20px;
  z-index: 2;
`;

export const RoutingRuleParameterJoiner = styled.div`
  position: absolute;
  height: calc(100% - 120px);
  top: 80px;
  left: 42px;
  z-index: 0;
  display: flex;
  justify-content: center;
  padding: 2px;
  grid-column-start: 1;
`;

export const RoutingRuleButtonGroup = styled(ButtonGroup<RoutingDataSource>)<{
  $speakUp?: boolean;
}>`
  width: ${({ $speakUp }) => ($speakUp ? '60%' : '100%')};
`;

export const RoutingRuleGroupAssignment = styled.div`
  margin-top: 16px;
`;

export const SpeakUpDataSourceDescription = styled.span`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
`;
